// extracted by mini-css-extract-plugin
module.exports = {"topics":"styles-module__topics___2BHLH","topic":"styles-module__topic___34uQ6"};